// Row fields for the records table, from what getHealthInfoRecords returns.
import { RECORDS_VIEW } from '../../constants/abdmCopy';

// Clinical date when the bundle has one, else the time we received the record.
export const recordDate = (r) => r.parsedSummary?.encounter?.period_start || r.createdAt;

export function recordSummary(r) {
  const s = r.parsedSummary || {};
  const meds = (s.medications || []).length;
  return [
    s.practitioner?.name,
    s.encounter?.chief_complaint,
    meds > 0 ? RECORDS_VIEW.medicines(meds) : '',
  ].filter(Boolean).join(' · ');
}
